import angular from 'angular';

import VerifyEmailNotificationComponent from './verify-email-notification.cmpt';

export default angular
    .module('application.component.notifications.component.verify-email-notification', [])
    .component(VerifyEmailNotificationComponent.selector, VerifyEmailNotificationComponent);



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/verify-email-notification/index.js